export default __webpack_public_path__ + "static/media/creditPortfolio.ca91a9e5.svg";